/* LEET quiz: start screen, optional contact step, questions, result with the right pack */
(function () {
  'use strict';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var CHK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ARR = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var KEY = 'lt-quiz-lead';

  function store(get, val) {
    try {
      if (get) return JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      window.sessionStorage.setItem(KEY, JSON.stringify(val));
    } catch (e) { return null; }
  }

  function init(box) {
    if (box.getAttribute('data-ready')) return;
    box.setAttribute('data-ready', '1');
    var cfgEl = box.querySelector('script[data-cfg]');
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var stage = box.querySelector('[data-stage]');
    var form = box.querySelector('[data-lt-qzform]');
    var T = cfg.texts || {}, L = cfg.lead || {}, qs = cfg.questions || [];
    var leadPos = form ? (L.pos || 'before') : 'off';
    var ans = [], i = 0, lock = false;

    function focusStage() {
      var h = stage.querySelector('h3');
      if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      var r = stage.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function hasLead() { var d = store(true); return !!(d && d.email); }

    /* Shopify > Customers: saved only with the consent tick. Tags carry the answers. */
    function sendLead(extra) {
      var d = store(true) || {};
      if (!form || !d.consent || !d.email) return;
      var parts = String(d.name || '').split(' ');
      var digits = String(d.phone || '').replace(/[^\d+]/g, '');
      var tags = ['quiz', 'quiz-lead'].concat(extra || []);
      if (digits) tags.push('tel ' + digits);
      try {
        form.querySelector('[name="contact[email]"]').value = d.email;
        form.querySelector('[name="contact[first_name]"]').value = parts.shift() || '';
        form.querySelector('[name="contact[last_name]"]').value = parts.join(' ');
        form.querySelector('[name="contact[tags]"]').value = tags.join(', ');
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      } catch (e) { try { form.submit(); } catch (e2) {} }
    }

    /* ---------- branching: a question shows for everyone ("all") or only for the chosen area ---------- */
    function areaOf(upTo) {
      var score = {}, order = [];
      qs.forEach(function (q, k) {
        if (k >= upTo || q.type !== 'score' || ans[k] == null || !shown(k, true)) return;
        var a = q.answers[ans[k]];
        if (!a || !a.target || a.target === 'none') return;
        score[a.target] = (score[a.target] || 0) + (q.weight || 1);
        if (order.indexOf(a.target) < 0) order.push(a.target);
      });
      return order.slice().sort(function (a, b) { return (score[b] || 0) - (score[a] || 0) || order.indexOf(a) - order.indexOf(b); })[0] || null;
    }
    function shown(k, raw) {
      var sh = qs[k].show || 'all';
      if (sh === 'all') return true;
      if (raw) return false;
      return areaOf(k) === sh;
    }
    function nextIdx(from) { for (var k = from + 1; k < qs.length; k++) if (shown(k)) return k; return -1; }
    function prevIdx(from) { for (var k = from - 1; k >= 0; k--) if (shown(k)) return k; return -1; }
    function counts() {
      var pos = 0, all = 0, per = {};
      qs.forEach(function (q, k) {
        var sh = q.show || 'all';
        if (sh === 'all') all++; else per[sh] = (per[sh] || 0) + 1;
        if (k <= i && shown(k)) pos++;
      });
      var area = areaOf(qs.length), extra = 0;
      if (area) extra = per[area] || 0; else Object.keys(per).forEach(function (x) { extra = Math.max(extra, per[x]); });
      return { pos: pos, n: all + extra };
    }
    function clean(t) { return String(t || '').replace(/[,\n\r]+/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 120); }

    /* ---------- contact step ---------- */
    function drawLead(after) {
      var d = store(true) || {};
      var h = '<div class="lt-qzl">';
      if (L.k) h += '<span class="lt-qzs__k">' + esc(L.k) + '</span>';
      h += '<h3>' + esc(L.t) + '</h3>';
      if (L.s) h += '<p class="lt-qzl__s">' + esc(L.s) + '</p>';
      h += '<form class="lt-qzl__f" novalidate>';
      h += '<label class="lt-qzl__i"><span>' + esc(L.name) + '</span><input type="text" name="name" autocomplete="name" required value="' + esc(d.name || '') + '"><em data-err="name"></em></label>';
      h += '<label class="lt-qzl__i"><span>' + esc(L.phone) + '</span><input type="tel" name="phone" autocomplete="tel" inputmode="tel" required placeholder="0888 123 456" value="' + esc(d.phone || '') + '"><em data-err="phone"></em></label>';
      h += '<label class="lt-qzl__i"><span>' + esc(L.email) + '</span><input type="email" name="email" autocomplete="email" inputmode="email" required value="' + esc(d.email || '') + '"><em data-err="email"></em></label>';
      h += '<label class="lt-qzl__c"><input type="checkbox" name="consent"' + (d.consent ? ' checked' : '') + '><i>' + CHK + '</i><span>' + esc(L.consent) + '</span></label>';
      h += '<button type="submit" class="lt-btn lt-btn--k">' + esc(after ? (L.btn2 || L.btn) : L.btn) + ARR + '</button>';
      h += '<small class="lt-qzl__n">' + esc(L.note) + ' <a href="' + esc(L.privacy) + '" target="_blank" rel="noopener">Поверителност</a></small>';
      h += '</form></div>';
      stage.innerHTML = h;
      box.classList.remove('lt-qz--done');
      box.classList.add('lt-qz--run');
      var f = stage.querySelector('form');
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var name = f.name.value.trim().replace(/\s+/g, ' ');
        var phone = f.phone.value.trim();
        var digits = phone.replace(/[^\d+]/g, '');
        var email = f.email.value.trim();
        var ok = true;
        function err(k, m) { var e = f.querySelector('[data-err="' + k + '"]'); if (e) e.textContent = m || ''; if (m) ok = false; }
        err('name', name.length < 2 ? L.err_name : '');
        err('phone', /^(\+?359|0)?8[789]\d{7}$/.test(digits.replace(/^00/, '+')) || /^\+?\d{9,15}$/.test(digits) ? '' : L.err_phone);
        err('email', /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) ? '' : L.err_email);
        if (!ok) { var bad = f.querySelector('[data-err]:not(:empty)'); if (bad) bad.parentNode.querySelector('input').focus(); return; }
        var consent = f.consent.checked;
        store(false, { name: name, phone: phone, email: email, consent: consent });
        /* before the questions: save the contact now, so it is kept even if the test is left half way; the answers follow at the result */
        if (!after) sendLead([]);
        try { if (window.fbq) window.fbq('track', 'Lead', { content_name: 'LEET quiz' }); } catch (e) {}
        if (after) result(); else { i = nextIdx(-1); drawQ(); }
      });
      focusStage();
    }

    /* ---------- questions ---------- */
    function drawQ() {
      var q = qs[i], c = counts(), n = c.n, pct = Math.round(c.pos / n * 100), last = nextIdx(i) < 0;
      var h = '<div class="lt-qzc__top"><span>' + esc(T.q || 'Въпрос') + ' <b>' + c.pos + '</b> ' + esc(T.of || 'от') + ' ' + n + '</span><span>' + pct + '%</span></div>';
      h += '<div class="lt-qzc__bar"><i style="width:' + pct + '%"></i></div><h3>' + esc(q.title) + '</h3>';
      if (q.sub) h += '<p class="lt-qzq__s">' + esc(q.sub) + '</p>';
      h += '<div class="lt-qos" role="radiogroup" aria-label="' + esc(q.title) + '">';
      (q.answers || []).forEach(function (a, j) {
        h += '<button type="button" role="radio" aria-checked="' + (ans[i] === j ? 'true' : 'false') + '" class="lt-qo' + (ans[i] === j ? ' on' : '') + '" data-a="' + j + '"><i style="--qc:' + esc(a.color || '') + '">' + esc(a.emoji || '') + '</i><span>' + esc(a.text) + '</span></button>';
      });
      h += '</div><div class="lt-qzc__nav"><button type="button" class="bk" data-back>← ' + esc(T.back || 'Назад') + '</button><button type="button" class="lt-btn lt-btn--k" data-next' + (ans[i] == null ? ' disabled' : '') + '>' + esc(last ? (T.finish || 'Виж резултата') : (T.next || 'Напред')) + ' →</button></div>';
      stage.innerHTML = h;
      box.classList.remove('lt-qz--done');
      box.classList.add('lt-qz--run');
      stage.querySelectorAll('[data-a]').forEach(function (b) {
        b.addEventListener('click', function () {
          ans[i] = parseInt(b.getAttribute('data-a'), 10);
          stage.querySelectorAll('[data-a]').forEach(function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
          stage.querySelector('[data-next]').disabled = false;
          setTimeout(next, 300);
        });
      });
      stage.querySelector('[data-back]').addEventListener('click', function () {
        var p = prevIdx(i);
        if (p >= 0) { i = p; drawQ(); focusStage(); }
        else if (leadPos === 'before') drawLead(false);
        else drawStart();
      });
      stage.querySelector('[data-next]').addEventListener('click', next);
    }
    function next() {
      if (lock || ans[i] == null) return;
      lock = true; setTimeout(function () { lock = false; }, 350);
      var nx = nextIdx(i);
      if (nx >= 0) { i = nx; drawQ(); focusStage(); }
      else if (leadPos === 'after' && !hasLead()) drawLead(true);
      else result();
    }

    /* ---------- where the answers go: Shopify customer tags, the order (cart attributes), Meta ---------- */
    function track(best, r, pk, pack, picked) {
      var tags = ['quiz-done', 'quiz-' + best];
      var attrs = {};
      picked.forEach(function (p) { tags.push(clean(p.tag) + ': ' + clean(p.text)); attrs['Тест · ' + clean(p.tag)] = clean(p.text); });
      attrs['Тест · Препоръка'] = clean(r.name) + (pk && pk.name ? ' · ' + clean(pk.name) : '');
      sendLead(tags);
      try {
        fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
      } catch (e) {}
      try {
        if (window.fbq) {
          var ev = { quiz_area: best, quiz_pack: pack || 2 };
          picked.forEach(function (p, k) { ev['quiz_q' + (k + 1)] = clean(p.text); });
          window.fbq('trackCustom', 'QuizComplete', ev);
        }
      } catch (e) {}
    }

    /* ---------- result ---------- */
    function result() {
      var msgs = [], pack = 0, picked = [];
      qs.forEach(function (q, k) {
        var a = q.answers && q.answers[ans[k]];
        if (!a || !shown(k)) return;
        picked.push({ tag: q.tag || q.title, text: a.text });
        if (a.msg && msgs.indexOf(a.msg) < 0) msgs.push(a.msg);
        if (q.type === 'pack') pack = ans[k] + 1;
      });
      /* at most 2 notes: the most personal one (first) and the closing one (last) */
      if (msgs.length > 2) msgs = [msgs[0], msgs[msgs.length - 1]];
      var res = cfg.results || {}, keys = Object.keys(res);
      var best = areaOf(qs.length) || keys[0];
      var r = res[best] || res[keys[0]];
      if (!r) return;
      if (!pack) pack = 2;
      var pk = (r.packs && r.packs[pack - 1]) || {};
      var url = r.url + (r.url.indexOf('?') < 0 ? '?' : '&') + 'pack=' + pack;
      var d = store(true) || {};
      var first = (d.name || '').split(' ')[0];
      var h = '<div class="lt-qzc__top"><span>' + esc(T.done || 'Готово') + '</span><span>100%</span></div><div class="lt-qzc__bar"><i style="width:100%"></i></div>';
      h += '<div class="lt-qzr lt-pv" style="' + esc(r.vars) + '"><span class="lt-qzs__k">' + esc(first ? first + ', ' + (T.result || 'Твоят резултат').toLowerCase() : (T.result || 'Твоят резултат')) + '</span>';
      h += '<div class="lt-qzr__p">' + (r.img ? '<img src="' + esc(r.img) + '" alt="" loading="lazy" width="200" height="200">' : '') + '<span><h3>' + esc(r.name) + '</h3>' + (r.desc ? '<small>' + esc(r.desc) + '</small>' : '') + '</span></div>';
      if (r.reasons && r.reasons.length) { h += '<ul>'; r.reasons.forEach(function (x) { h += '<li><i>' + CHK + '</i><span>' + esc(x) + '</span></li>'; }); h += '</ul>'; }
      msgs.forEach(function (m) { h += '<div class="lt-qzr__m">' + esc(m) + '</div>'; });
      if (pk.name) {
        h += '<div class="lt-qzr__o"><span class="lt-qzr__ok">' + esc(T.pack || 'Препоръчваме ти') + '</span><div class="lt-qzr__or"><b>' + esc(pk.name) + '</b><span class="lt-qzr__pp">' + (pk.old ? '<s>' + esc(pk.old) + '</s>' : '') + '<b>' + esc(pk.price) + '</b></span></div>' + (pk.note ? '<small>' + esc(pk.note) + '</small>' : '') + '</div>';
      }
      h += '<div class="lt-qzr__b"><a class="lt-btn lt-btn--k" href="' + esc(url) + '">' + esc(T.buy || 'Вземи моя пакет') + ARR + '</a><button type="button" class="lt-qzr__re" data-restart>' + esc(T.restart || 'Започни отново') + '</button></div></div>';
      stage.innerHTML = h;
      box.classList.add('lt-qz--done');
      track(best, r, pk, pack, picked);
      stage.querySelector('[data-restart]').addEventListener('click', function () { ans = []; i = nextIdx(-1); drawQ(); focusStage(); });
      focusStage();
    }

    /* ---------- start ---------- */
    var startHTML = stage.innerHTML;
    function bindStart() {
      var go = stage.querySelector('[data-start]');
      if (go) go.addEventListener('click', function () {
        ans = []; i = nextIdx(-1);
        if (leadPos === 'before' && !hasLead()) drawLead(false);
        else { drawQ(); focusStage(); }
      });
    }
    function drawStart() { stage.innerHTML = startHTML; box.classList.remove('lt-qz--run', 'lt-qz--done'); bindStart(); }
    if (qs.length) bindStart();
  }

  function boot() { document.querySelectorAll('[data-lt-qz2]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
